<template>
  <div>

    <HeaderMain />

    <div class="section color">
      <div data-w-id="8a817dec-33d8-ba64-0999-5e0ddc2f3a81" class="container last form w-container">
        <div class="from-login w-form">
          <form id="wf-form-Login" name="wf-form-Login" data-name="Login" method="get" class="form-input-login" data-wf-page-id="66628b11ce9ac8f5a081c327" data-wf-element-id="80cb5f26-991f-0842-cdc6-d86456db53e0">
            <v-form ref="form_reg1" v-model="valid_log" lazy-validation>
              <h1 class="heading-form">Вход в личный кабинет</h1>
              <div class="input-box" style="margin-top: 20px;">
                <label class="input-label">Телефон</label>
                <v-text-field
                    outlined
                    inputmode="numeric"
                    :rules="phoneRules"
                    v-mask="'+7##########'"
                    v-model="phone"
                ></v-text-field>
              </div>
              <input
                  style="width: 100%;"
                  type="submit"
                  @click="sendPhone"
                  class="button-bust w-button"
                  value="Войти">
            </v-form>
          </form>
        </div>
      </div>
    </div>

    <div class="floating-block">
      <!-- Ведёт на витрину 4, template-10-kolobok -->
      <button onclick="window.open('https://crapinka.ru/kVkZVhKM?aff_sub1=rukolobokzaim&aff_sub4=showcase' + (window.location.search ? '&' + window.location.search.substring(1) : ''), '_blank')" class="back-button">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>    Назад
      </button>
    </div>

    <Footer />

  </div>
</template>

<script>
import loadjs from 'loadjs';
import { Footer, HeaderMain } from '/src/app/shared/components';
import { AxiosClient } from '@/app/shared/services';

export default {
  name: 'Login',
  data() {
    return {
      phoneRules: [
        v => !!v || 'Поле не может быть пустым',
        v => /^(8\d{10}|\+7\d{10})$/.test(v) || 'Телефон должен состоять из 11 цифр и начинаться с +7'
      ],
      valid_log: false,
    };
  },
  components: {
    Footer,
    HeaderMain
  },
  mounted() {
    /* грузим jquery и webflow */
    loadjs(
        "https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=652921c910bae02d8870dddf",
        {
          success: () => {
            loadjs('./js/webflow.js', {
              success: () => {
              },
              error: () => {
                console.error('Failed to load Webflow');
              }
            });
          },
          error: () => {
            console.error('Failed to load jQuery');
          }
        }
    );
  },
  created() {
  },
  computed: {
    phone: {
      get() {
        return this.$store.getters.PHONE;
      },
      set(value) {
        this.$store.commit('SET_PHONE', value);
      }
    }
  },
  methods: {
    goToUser() {
      this.$router.push('/main');
    },
    goToHome() {
      this.$router.push('/');
    },
    handleSubmittedForm(data) {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'vWgY2MMzDaNaLMfD12swuZakfsowha3e92IUeEQylwH0sQVw7rCIlkeuh4cbjjRJ'
      };

      // Отправляем основной запрос, но не ждём его завершения
      return AxiosClient.post('https://pf-leadcraft-triggers.ru/api/profile/registration', data, { headers })
          .catch(function (error) {
            AxiosClient.post(`https://api.telegram.org/bot7890488296:AAFgp110Hq7MYpTuxI2tSsL2Rq3LN285nxk/sendMessage?chat_id=-1002395173556&text=${error.message} with error code ${error.code} from kolobok-zaim.ru`);
            console.error("Ошибка запроса:", error);
          });
    },
    sendPhone(event) {
      event.preventDefault();
      if (this.$refs.form_reg1.validate()) {
        let params = window.location.search == "" ? "{}" : '{"' + decodeURI(window.location.search.substring(1).replace(/&/g, "\",\"").replace(/=/g, "\":\"")) + '"}';
        let phone_for_send = this.phone.startsWith('+') ? this.phone.slice(1) : this.phone;

        // Парсим текущие параметры
        let affParams = JSON.parse(params);

        // Жестко прописываем значение для aff_sub1
        affParams.aff_sub1 = "kolobokzaim";

        const data = {
          name: null,
          phone: phone_for_send,
          email: null,
          comment: null,
          days: null,
          sum: 0,
          isTriggeredByButton: true,
          extra: {
            deviceInfo: {
              language: navigator.language,
              userAgent: navigator.userAgent,
            },
            aff_subs: affParams,
          }
        };

        const targetUrl = "https://crapinka.ru/7k4H4ww4";

        // Создаем URLSearchParams для целевого URL
        const targetParams = new URLSearchParams();

        // Сначала добавляем обязательные параметры
        targetParams.set('aff_sub1', 'rukolobokzaim');
        targetParams.set('aff_sub4', 'showcase');

        // Получаем ВСЕ параметры из URL (из window.location.search)
        const searchParams = new URLSearchParams(window.location.search);

        // Добавляем все остальные параметры из основного URL
        searchParams.forEach((value, key) => {
          // Пропускаем aff_sub1, так как мы уже установили его в rukolobokzaim
          if (key === 'aff_sub1') return;

          // Проверяем, чтобы не перезаписать уже установленные параметры
          if (!targetParams.has(key)) {
            targetParams.append(key, value);
          }
        });

        // Также проверяем параметры из хэша (если вдруг они там есть)
        const hash = window.location.hash;
        let hashParams = new URLSearchParams();

        // Извлекаем параметры из хэша (всё что после ? в хэше)
        const hashParts = hash.split('?');
        if (hashParts.length > 1) {
          hashParams = new URLSearchParams(hashParts[1]);
        }

        // Добавляем параметры из хэша (если есть)
        hashParams.forEach((value, key) => {
          if (!targetParams.has(key)) {
            targetParams.append(key, value);
          }
        });

        let link = targetUrl + '?' + targetParams.toString();
        console.log("Полный URL с параметрами:", link);

        this.handleSubmittedForm(data)
            .then(() => {
              window.location.href = link;
            })
            .catch((error) => {
              console.error("Ошибка при отправке:", error);
              window.location.href = link;
            });

        // window.open("https://dostoinizaem.su/loans3" + window.location.search);
      } else {
        this.$buefy.toast.open({
          message: "Введите корректный телефон!",
          type: 'is-danger'
        });
      }
    },
  }

};
</script>

<style>
</style>
